/**
 * Project show components
 */
const Projects = r => require.ensure([], () => r(require('../components/projects/views/Projects')), 'projects-show')
const ProjectGaap = r => require.ensure([], () => r(require('../components/projects/single/ProjectGaap')), 'projects-show')
const ProjectDebt = r => require.ensure([], () => r(require('../components/projects/single/ProjectDebt')), 'projects-show')
const ProjectOpex = r => require.ensure([], () => r(require('../components/projects/single/ProjectOpex')), 'projects-show')
const ProjectsShow = r => require.ensure([], () => r(require('../components/projects/views/ProjectsShow')), 'projects-show')
const ProjectCapex = r => require.ensure([], () => r(require('../components/projects/single/ProjectCapex')), 'projects-show')
const ProjectIncome = r => require.ensure([], () => r(require('../components/projects/single/ProjectIncome')), 'projects-show')
const ProjectEquity = r => require.ensure([], () => r(require('../components/projects/single/ProjectEquity')), 'projects-show')
const ProjectSummary = r => require.ensure([], () => r(require('../components/projects/single/ProjectSummary')), 'projects-show')
const ProjectCashFlow = r => require.ensure([], () => r(require('../components/projects/single/ProjectCashFlow')), 'projects-show')
const ProjectActivity = r => require.ensure([], () => r(require('../components/projects/single/ProjectActivity')), 'projects-show')
const ProjectDevBudget = r => require.ensure([], () => r(require('../components/projects/single/ProjectDevBudget')), 'projects-show')
const ProjectFromTemplate = r => require.ensure([], () => r(require('../components/projects/views/ProjectFromTemplate')), 'projects-show')
const ProjectClosingCosts = r => require.ensure([], () => r(require('../components/projects/single/ProjectClosingCosts')), 'projects-show')
const ProjectUserManagement = r => require.ensure([], () => r(require('../components/projects/single/ProjectUserManagement')), 'projects-show')

/**
 * General project components
 */
const ProjectInbox = r => require.ensure([], () => r(require('../components/projects/views/ProjectInbox')), 'projects-general')
const ProjectLinks = r => require.ensure([], () => r(require('../components/projects/views/ProjectLinks')), 'projects-general')
const ProjectInvitations = r => require.ensure([], () => r(require('../components/projects/views/ProjectInvitations')), 'projects-general')

/**
 * Project edit components
 */
const ProjectEdit = r => require.ensure([], () => r(require('../components/projects/views/ProjectEdit')), 'projects-edit')

/**
 * Project create components
 */
const ProjectCreate = r => require.ensure([], () => r(require('../components/projects/views/ProjectCreate')), 'projects-create')
const ProjectChoices = r => require.ensure([], () => r(require('../components/projects/views/ProjectChoices')), 'projects-create')

/**
 * Project Routes
 */
export default {
    path: 'projects',
    component: Projects,
    redirect: '/',
    children: [
        {
            path: 'choose-project-type',
            name: 'projects.choices',
            component: ProjectChoices
        },
        {
            path: 'create',
            name: 'projects.create',
            component: ProjectCreate
        },
        {
            path: 'links',
            name: 'projects.links',
            component: ProjectLinks
        },
        {
            path: 'invitations',
            name: 'projects.invitations',
            component: ProjectInvitations
        },
        {
            path: 'inbox',
            name: 'projects.inbox',
            component: ProjectInbox
        },
        {
            path: ':projectId',
            component: ProjectsShow,
            children: [
                {
                    path: '',
                    name: 'projects.tearsheet',
                    component: ProjectSummary
                },
                {
                    path: 'development-budget',
                    name: 'projects.devbudget',
                    component: ProjectDevBudget
                },
                {
                    path: 'income',
                    name: 'projects.income',
                    component: ProjectIncome
                },
                {
                    path: 'gaap',
                    name: 'projects.gaap',
                    component: ProjectGaap
                },
                {
                    path: 'cash_flow',
                    name: 'projects.cash_flow',
                    component: ProjectCashFlow
                },
                {
                    path: 'opex',
                    name: 'projects.opex',
                    component: ProjectOpex
                },
                {
                    path: 'capex',
                    name: 'projects.capex',
                    component: ProjectCapex
                },
                {
                    path: 'equity',
                    name: 'projects.equity',
                    component: ProjectEquity
                },
                {
                    path: 'debt',
                    name: 'projects.debt',
                    component: ProjectDebt
                },
                {
                    path: 'closing-costs',
                    name: 'projects.closing_costs',
                    component: ProjectClosingCosts
                },
                {
                    path: 'user-management',
                    name: 'projects.userManagement',
                    component: ProjectUserManagement
                },
                {
                    path: 'activity',
                    name: 'projects.activity',
                    component: ProjectActivity
                }
            ]
        },
        {
            path: ':projectId/edit',
            name: 'projects.edit',
            component: ProjectEdit
        },
        {
            path: 'template/:templateId',
            name: 'projects.template',
            component: ProjectFromTemplate
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/projects.js